import { render, staticRenderFns } from "./ListarAlumnosPorProfe.vue?vue&type=template&id=fb185866&"
import script from "./ListarAlumnosPorProfe.vue?vue&type=script&lang=js&"
export * from "./ListarAlumnosPorProfe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports